import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  get1sxyiyz2qwf4j as get,
  set13o7dd1nq2lc5 as set,
  Attributes2dg90yv0ot9wx as Attributes,
} from './Attributes.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AttributesJsFn(concurrent) {
  concurrent = concurrent === VOID ? false : concurrent;
  return new (AttributesJs())();
}
var AttributesJsClass;
function AttributesJs() {
  if (AttributesJsClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.w4s_1 = LinkedHashMap().bc();
      }
      k4m(key) {
        return this.w4s_1.u4(key);
      }
      l4m(key) {
        return this.w4s_1.s4(key);
      }
      m4m(key, value) {
        // Inline function 'kotlin.collections.set' call
        this.w4s_1.x4(key, value);
      }
      o4m(key) {
        this.w4s_1.y4(key);
      }
      p4m(key, block) {
        var tmp0_safe_receiver = this.w4s_1.u4(key);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
        }
        // Inline function 'kotlin.also' call
        var this_0 = block();
        // Inline function 'kotlin.collections.set' call
        this.w4s_1.x4(key, this_0);
        return this_0;
      }
      q4m() {
        return toList(this.w4s_1.v4());
      }
    }
    protoOf($).j4m = get;
    protoOf($).n4m = set;
    initMetadataForClass($, 'AttributesJs', AttributesJs, VOID, [Attributes()]);
    AttributesJsClass = $;
  }
  return AttributesJsClass;
}
//region block: exports
export {
  AttributesJsFn as AttributesJsFn25rjfgcprgprf,
};
//endregion

//# sourceMappingURL=Attributes.web.mjs.map
